import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    nguoi_check_in_id: null, // required Mã người đến checkin
    diem_den_an_toan_id: null, // required Mã điểm đến an toàn
    thoi_diem_check_in: null, // required Thời điểm check in
    nguoi_tao_id: null, // required Mã người tạo
    danh_gia: // optional Thông tin đánh giá
    {
        gia_tri: null, // required, min: 1, max: 5 Số sao đánh giá của người dùng
        noi_dung: null, // optional Nội dung đánh giá
        thanh_phan: [ // optional Danh sách các đánh giá thành phần
        {
            nhom_id: null, // required Mã nhóm thành phần
            gia_tri: null, // required, enum(-1, 0, 1) Giá trị đánh giá thành phần
        }],
        thoi_diem_tao: null, // required Thời điểm tạo
        thong_tin_them: // optional Lưu thông tin thêm của từng đánh giá
        {
            kpis: [], // optional Thong tin kpi
        }
    }
};

// validation form
model.validForm = {
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["danh_gia.thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            diem_den_an_toan_id: "",
            "danh_gia.gia_tri": "",
            "danh_gia.thoi_diem_tao": "",
        },
        valid: {
            diem_den_an_toan_id: [],
            "danh_gia.gia_tri": [],
            "danh_gia.thoi_diem_tao": []
        },
        operator: {
            "danh_gia.gia_tri": "=",
            "danh_gia.thoi_diem_tao": ":in_that_day:"
        }
    }
};

model.loaiDoiTuongDanhGia = [{
        code: "tour",
        text: "Tour du lịch"
    },
    {
        code: "tour_guide",
        text: "Hướng dẫn viên"
    },
    {
        code: "hq_service",
        text: "Dịch vụ du lịch clc"
    },
    {
        code: "safe_place",
        text: "Điểm đến an toàn"
    },
    {
        code: "accommodation",
        text: "Cơ sở lưu trú"
    },
    {
        code: "tourist",
        text: "Khách du lịch"
    },
];

export default model;
